import {combineReducers} from 'redux';
import _ from 'lodash';
import uuidv1 from 'uuid';
import {
    CLEAR_DIPLOMA,
    SET_DIPLOMA,
    SET_EMBEDDED,
    SET_LOADING,
    SET_MESSAGE,
    SET_SHOW_HEADER,
    SET_SHOW_BACKGROUND, SET_HISTORICO_PARCIAL, CLEAR_HISTORICO_PARCIAL
} from '../actions/actionTypes';
import {MESSAGE_INFO} from '../constants/index';

const initialState = {
    isLoading: false,
    message: {
        id: null,
        type: MESSAGE_INFO,
        text: null
    },
    embedded: false,
    showHeader: true,
    showBackground: true,
    diploma: null,
    historicoParcial: null
};

const isLoading = (state = initialState.isLoading, action) => {
    switch (action.type) {
        case SET_LOADING:
            return action.isLoading;
        default:
            return state;
    }
};

const message = (state = initialState.message, action) => {
    switch (action.type) {
        case SET_MESSAGE:
            return _.assign({}, state, { 
                id: uuidv1(), 
                type: action.typeMessage, 
                text: action.text 
            });
        default:
            return state;
    }
};

const embedded = (state = initialState.embedded, action) => {
    switch (action.type) {
        case SET_EMBEDDED:
            return action.embedded ? action.embedded : false;
        default:
            return state;
    }
};

const showHeader = (state = initialState.showHeader, action) => {
    switch (action.type) {
        case SET_SHOW_HEADER:
            return action.showHeader ? action.showHeader : false;
        default:
            return state;
    }
};

const showBackground = (state = initialState.showBackground, action) => {
    switch (action.type) {
        case SET_SHOW_BACKGROUND:
            return action.showBackground ? action.showBackground : false;
        default:
            return state;
    }
};

const diploma = (state = initialState.diploma, action) => {
    switch (action.type) {
        case SET_DIPLOMA:
            return {...action.diploma};
        case CLEAR_DIPLOMA:
            return null;
        default:
            return state;
    }
};

const historicoParcial = (state = initialState.historicoParcial, action) => {
    switch (action.type) {
        case SET_HISTORICO_PARCIAL:
            return {...action.historicoParcial};
        case CLEAR_HISTORICO_PARCIAL:
            return null;
        default:
            return state;
    }
};

const appReducer = combineReducers({
    isLoading,
    message,
    embedded,
    showHeader,
    showBackground,
    diploma,
    historicoParcial
});

export default appReducer;